import React from 'react'

import { TableComponents, Skeleton } from '@sketch/components'

import { MethodWrapper, ActionCell } from './SignInMethods.styles'

export const SkeletonRow: React.FCC = () => (
  <TableComponents.TableRow>
    <TableComponents.TableCell>
      <MethodWrapper>
        <Skeleton height="24px" width="24px" />
        <Skeleton height="16px" width="100px" />
      </MethodWrapper>
    </TableComponents.TableCell>
    <TableComponents.TableCell>
      <ActionCell>
        <Skeleton height="16px" width="150px" />
        <Skeleton height="40px" width="40px" />
      </ActionCell>
    </TableComponents.TableCell>
  </TableComponents.TableRow>
)
